import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IPendingNotificationsQueueStore {
	/** Trip delay notification data */
	delay: { bookingNumber: string } | null;
	/** Trip feedback notification data */
	feedback: { bookingId: string } | null;

	/** Set delay notification data */
	setDelay: (data: { bookingNumber: string }) => void;
	/** Set feedback notification data */
	setFeedback: (data: { bookingId: string }) => void;
	/** Clear delay notification */
	clearDelay: () => void;
	/** Clear feedback notification */
	clearFeedback: () => void;
	/** Reset all notifications to initial state */
	reset: () => void;
}

const initialState = {
	delay: null,
	feedback: null,
};

export const usePendingNotificationsQueueStore =
	create<IPendingNotificationsQueueStore>()(
		persist(
			(set) => ({
				...initialState,

				setDelay: (data) => set({ delay: data }),
				setFeedback: (data) => set({ feedback: data }),
				clearDelay: () => set({ delay: null }),
				clearFeedback: () => set({ feedback: null }),
				reset: () => set(initialState),
			}),
			{
				name: 'notificationStorage',
			}
		)
	);
